'use client';

import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import { ImgParallax } from '@/components/common/ui/images/ImgParallax';
import { StyledInnerBannerDetailsSub } from '@/components/common/ygen/sections/inner-banner-details-sub/inner-banner-details-sub.style';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import useDeviceTypeMobile from '@/components/hooks/useDeviceTypeMobile';
import Link from 'next/link';
import reactHtmlParser from 'react-html-parser';

const InnerBanner = ({
	data,
	imageScroll,
	inidustry,
	image,
	title,
	short_desc,
	solution,
	product,
	icon,
	video,
	impact,
	mainData,
	breadcrumbTitle = 'Impact Stories',
	breadcrumbHref = '/impact-stories',
}) => {
	const bannerImge = data?.images?.list?.find(f => f?.banner === 'on');
	const thumbImage = data?.images?.list?.find(f => f?.thumb === 'on');
	const offset = useContainerOffset('.container');
	const isMobile = useDeviceTypeMobile();
	const [wrapperHeight, setWrapperHeight] = useState(false);
	useEffect(() => {
		if (document.querySelector('.inner-banner-details')?.offsetHeight) {
			setWrapperHeight(
				document.querySelector('.inner-banner-details')?.offsetHeight,
			);
		}
	}, [wrapperHeight]);

	return (
		<>
			<StyledInnerBannerDetailsSub
				offset={offset}
				getHeight={wrapperHeight}
				className={`InnerBanner ${imageScroll ? 'forImageScroll' : ''} ${bannerImge?.for_project === 'on' ? 'for_projects' : ''} ${solution ? 'solution' : ''}`}
				data-scroll-section>
				{image && (
					<div>
						{imageScroll ? (
							<ImgParallax
								banner={true}
								priority={true}
								src={image ? image : ''}
							/>
						) : (
							<ImgParallax
								parallax
								banner={true}
								priority={true}
								src={image ? image : ''}
							/>
						)}
					</div>
				)}

				{video && (
					<div className="video__inner">
						<video
							loop
							autoPlay
							playsInline
							muted
							preload="metadata" // Add this to improve performance
						>
							<source src={video} type="video/mp4" />
						</video>
					</div>
				)}
				<Container>
					<Row>
						<Col md={6}>
							<ul
								className={
									'd-flex justify-content-start breadcrumb-ygen'
								}>
								{inidustry && (
									<>
										<li>
											<Link href={'/'}>Home</Link>
										</li>
										<li>/</li>
									</>
								)}
								{solution && (
									<>
										<li>
											<Link href={'/'}>Home</Link>
										</li>
										<li>/</li>
									</>
								)}
								{product && (
									<>
										<li>
											<Link href={'/'}>Home</Link>
										</li>
										<li>/</li>
									</>
								)}

								{impact && (
									<>
										<li>
											<Link href={'/'}>Home</Link>
										</li>
										<li>/</li>
									</>
								)}

								<li>
									<Link
										href={
											inidustry
												? '/industries-empowered'
												: solution
													? '/solution-spectrum'
													: product
														? '/products'
														: impact
															? breadcrumbHref
															: '/'
										}>
										{inidustry
											? 'Industries Empowered'
											: solution
												? 'Solution Spectrum'
												: product
													? 'Products'
													: impact
														? breadcrumbTitle
														: 'Home'}
									</Link>
								</li>
								<li>/</li>
								<li>
									{title && (
										<span className="breadcrumb-current">
											{reactHtmlParser(title)}
										</span>
									)}
								</li>
							</ul>
						</Col>
					</Row>
				</Container>
				{!isMobile && (
					<div
						className={'inner-banner-details'}
						style={{ paddingLeft: offset + 15 + 'px' }}>
						<div className="fixed-right-Inner">
							<svg
								width="852"
								height="359"
								viewBox="0 0 852 359"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									opacity="0.2"
									d="M822.391 193.545C875.553 269.55 903.913 360.135 903.584 452.887L753.009 452.556C753.036 443.781 752.68 435 751.942 426.214C747.405 373.556 729.106 323.015 698.879 279.659C668.652 236.302 627.558 201.653 579.718 179.185C485.527 135.13 371.061 141.106 279.626 204.852C239.895 232.509 207.427 269.346 184.98 312.236C162.532 355.125 150.769 402.8 150.689 451.208L0.109239 450.872C0.157887 432.997 1.26968 415.141 3.43873 397.399C18.4264 274.296 83.7724 157.843 193.512 81.3347C303.252 4.82666 435.11 -16.2058 555.808 12.3002C663.999 37.7269 758.957 102.287 822.391 193.545Z"
									fill="url(#paint0_linear_506_5137)"
								/>
								<defs>
									<linearGradient
										id="paint0_linear_506_5137"
										x1="502.147"
										y1="73.2785"
										x2="690.131"
										y2="249.081"
										gradientUnits="userSpaceOnUse">
										<stop
											stopColor="white"
											stopOpacity="0"
										/>
										<stop offset="1" stopColor="white" />
									</linearGradient>
								</defs>
							</svg>
						</div>
						{icon && (
							<div className="icon">
								<img src={icon} alt={title ? title.replace(/<[^>]*>/g, '') : ''} />
							</div>
						)}
						<div className="wrapper">
							<Container>
								<Row>
									{mainData?.specifications &&
										mainData?.specifications.length > 0 && (
											<Col md={12}>
												<ul className="d-flex justify-content-start banner-links gap-2 mb-3">
													{mainData?.specifications?.map(
														(item, index) => (
															<li key={index}>
																<Link
																	href={
																		item?.item_value
																			? item?.item_value
																			: '#'
																	}>
																	{item?.item_title
																		? item?.item_title
																		: 'Untitled'}
																</Link>
															</li>
														),
													)}
												</ul>
											</Col>
										)}

									<Col md={10}>
										{title && (
											<h1 className={`fade-up`}>
												{reactHtmlParser(title)}
											</h1>
										)}
										<p className={'fade-up'}>
											{short_desc &&
												reactHtmlParser(short_desc)}
										</p>
									</Col>
								</Row>
							</Container>
						</div>
					</div>
				)}
			</StyledInnerBannerDetailsSub>
			{isMobile && (
				<StyledInnerBannerDetailsSub
					className={`forMobileOne ${solution ? 'solution' : ''}`}>
					<div
						className={'inner-banner-details '}
						style={{ paddingLeft: offset + 15 + 'px' }}>
						<div className="wrapper">
							<Container>
								<Row>
									<Col md={10}>
										{title && (
											<h1 className={`fade-up`}>
												{reactHtmlParser(title)}
											</h1>
										)}

										{icon && (
											<div className="icon">
												<img src={icon} alt={title ? title.replace(/<[^>]*>/g, '') : ''} />
											</div>
										)}
										<p className={'fade-up'}>
											{short_desc &&
												reactHtmlParser(short_desc)}
										</p>
									</Col>
								</Row>
							</Container>
						</div>
					</div>
				</StyledInnerBannerDetailsSub>
			)}
		</>
	);
};

export default React.memo(InnerBanner);
